import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueCookies from 'vue-cookies'


import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowRightToBracket, faBarsStaggered, faPlus, faArrowLeft, faArrowRightFromBracket, faXmark } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare, faUser } from '@fortawesome/free-regular-svg-icons'

library.add(faArrowRightToBracket, faBarsStaggered, faPlus, faPenToSquare, faUser, faArrowLeft, faArrowRightFromBracket, faXmark)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false
axios.defaults.baseURL = 'https://api.qimp.cz'
axios.defaults.withCredentials = true;

Vue.use(VueCookies)

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
